import { actions as collection } from '@/plugins/Collection'

export default collection.toEnumOptions([
  'First Charge',
  'Second Charge',
  'Unsecured'
])
